<template>
    <ui-modal id="candidates-job" title="Candidatos" title-text="Estes são os candidatos à vaga de emprego." size="lg">
        <div class="candidates">
            <section class="load" v-if="load"></section>
            <table v-if="!load && total">
                <thead>
                    <tr>
                        <th width="50">Foto</th>
                        <th>Nome</th>
                        <th width="50">Telefone</th>
                        <th width="50">Pretensão Salarial</th>
                        <th width="50">Currículo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="candidate in candidates" :key="candidate.id">
                        <td>
                            <img :src="candidate.user.avatar">
                        </td>
                        <td>{{candidate.user.first_name}} {{candidate.user.last_name}}</td>
                        <td>{{candidate.user.mobile}}</td>
                        <td>{{candidate.user.desired_salary}}</td>
                        <td>
                            <button type="button" class="btn" @click="go(candidate)">Visualizar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ui-no-result v-if="!total && !load" text="Nenhum candidato encontrado." />
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal, uiNoResult } from '@/components'
    import { jobs  } from '@/services'
    
    export default {
        components: { uiModal, uiNoResult },
        data() {
            return {
                value: [],
                candidates: [],
                data: null,
                load: false,
                total: 0,
            }
        },
        methods: {
            modal(action, id){
                this.$root.$emit(action, id);
            },
            go(candidate){
                let route = this.$router.resolve({ path: '/curriculo/' + candidate.user_id })
                window.open(route.href, '_blank');

                
            },
            getCandidates(){
                this.load = true
                jobs.getCandidates(this.data.id).then( response => {
                    this.candidates = response.data.rows
                    this.total = response.data.total * 1
                    this.load = false
                })
            }
        },
        created(){
            this.$parent.$on('get-candidates', (data) => {
                this.data = data
                this.getCandidates()
            })
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
